module.exports = __webpack_public_path__ + "img/logo.4966c993.png";